"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCanonicalSellerId = exports.handleSellerServiceError = void 0;
const commons_logs_1 = require("@deliverr/commons-logs");
const errors_1 = require("@deliverr/errors");
function handleSellerServiceError(functionName, err, logData) {
    const ctx = Object.assign({ functionName }, logData);
    if (!err.response) {
        const unknownError = new errors_1.DeliverrError({
            code: errors_1.ApiError.UNKNOWN_ERROR,
            functionName,
            payload: err,
        });
        commons_logs_1.log.info(Object.assign(Object.assign({}, ctx), { err }));
        throw unknownError;
    }
    if (err.response.data.subcode) {
        const reportableError = new errors_1.DeliverrError({
            code: err.response.data.subcode,
            functionName,
        });
        commons_logs_1.log.info(Object.assign(Object.assign({}, ctx), { err: reportableError }));
        throw reportableError;
    }
    else {
        const unknownError = new errors_1.DeliverrError({
            code: err.response.data.toString(),
            functionName,
            payload: err,
        });
        commons_logs_1.log.info(Object.assign(Object.assign({}, ctx), { err }));
        throw unknownError;
    }
}
exports.handleSellerServiceError = handleSellerServiceError;
function generateCanonicalSellerId(sellerName) {
    return sellerName.toLowerCase().replace(/[^A-Za-z0-9]/g, "");
}
exports.generateCanonicalSellerId = generateCanonicalSellerId;
//# sourceMappingURL=SellerServiceUtil.js.map